import styled from "styled-components";
import CustomScrollBar from "~/componentes/CustomScrollBar";

export const ScrollBarCustom = styled(CustomScrollBar)`
  margin-right: -2rem;
  margin-bottom: -2rem;
  max-height: calc(100% - 4rem) !important;
  height: 100% !important;
`;
